import { Link, useRouterState } from "@tanstack/react-router";
import {
  LayoutDashboard,
  ShoppingBag,
  MapPin,
  Heart,
  User,
  Bell,
  CreditCard,
  CalendarCheck2,
  LifeBuoy,
  Shield,
  RotateCcw,
  FileBadge,
  Sparkles,
} from "lucide-react";

const items = [
  { to: "/portal", icon: LayoutDashboard, label: "Overview", exact: true },
  { to: "/portal/orders", icon: ShoppingBag, label: "My Orders" },
  { to: "/portal/bookings", icon: CalendarCheck2, label: "Service Bookings" },
  { to: "/portal/tickets", icon: LifeBuoy, label: "Support Tickets" },
  { to: "/portal/wishlist", icon: Heart, label: "Wishlist" },
  { to: "/portal/addresses", icon: MapPin, label: "Addresses" },
  { to: "/portal/payments", icon: CreditCard, label: "Payments" },
  { to: "/portal/warranty", icon: FileBadge, label: "Warranty" },
  { to: "/portal/returns", icon: RotateCcw, label: "Returns" },
  { to: "/portal/notifications", icon: Bell, label: "Notifications" },
  { to: "/portal/profile", icon: User, label: "Profile" },
  { to: "/portal/security", icon: Shield, label: "Security" },
];

export function CustomerSidebar({ collapsed }: { collapsed: boolean }) {
  const path = useRouterState({ select: (s) => s.location.pathname });
  return (
    <aside
      className={`sticky top-0 h-screen shrink-0 border-r border-sidebar-border bg-sidebar text-sidebar-foreground transition-all duration-300 ${collapsed ? "w-16" : "w-64"}`}
    >
      <div className="flex h-16 items-center gap-2 px-4 border-b border-sidebar-border">
        <div className="grid h-9 w-9 place-items-center rounded-xl bg-gradient-primary shadow-glow">
          <Sparkles className="h-5 w-5 text-primary-foreground" />
        </div>
        {!collapsed && (
          <div className="leading-tight">
            <div className="text-sm font-semibold tracking-tight">Kizak</div>
            <div className="text-[10px] uppercase tracking-widest text-muted-foreground">
              My Account
            </div>
          </div>
        )}
      </div>
      <nav className="flex flex-col gap-0.5 px-2 py-4">
        {items.map((it) => {
          const active = it.exact
            ? path === it.to
            : path === it.to || path.startsWith(it.to + "/");
          return (
            <Link
              key={it.to}
              to={it.to}
              className={`flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition ${
                active
                  ? "bg-sidebar-accent text-sidebar-primary font-medium"
                  : "text-sidebar-foreground/80 hover:bg-sidebar-accent/60 hover:text-sidebar-foreground"
              }`}
            >
              <it.icon className="h-4 w-4 shrink-0" />
              {!collapsed && <span>{it.label}</span>}
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}